import URI from "urijs";
import flatpickr from "flatpickr";

document.addEventListener("DOMContentLoaded", function(event) {
  /*----------------------------------------------------------------------------------*/
  /* Booking - Guest Selector
      /*----------------------------------------------------------------------------------*/


  // Open Select
  $(".guest-selector .guest-selector-trigger").click(function(e) {
    e.stopPropagation();
    $(this)
      .parent()
      .find(".guest-select")
      .addClass('guest-select--show');
  });

  $(".guest-select").click(function(e) {
    e.stopPropagation();
  });

  // Close Select
  $(document).on("click", function() {
    $(".guest-selector .guest-select").removeClass('guest-select--show');;
  });

  // Functions for counter
  $(".guest-counter a").click(function(e) {
    e.preventDefault();
    e.stopPropagation();

    var value = $(this)
      .closest("li")
      .find("input")
      .val();

    if ($(this).hasClass("plus")) {
      $(this)
        .closest("li")
        .find("input")
        .val(parseInt(value) + 1);
    } else {
      if (value > 1) {
        $(this)
          .closest("li")
          .find("input")
          .val(parseInt(value) - 1);
      }
    }

    value = $(this)
      .closest("li")
      .find("input")
      .val();

    $(this)
      .parent()
      .find("a.minus")
      .addClass("disabled");

    if (value > 1) {
      $(this)
        .parent()
        .find("a.minus")
        .removeClass("disabled");
    } else {
      $(this)
        .parent()
        .find("a.minus")
        .addClass("disabled");
    }

    $(this)
      .closest("li")
      .find("input")
      .trigger("change");
  });

  $(".guest-selector .guest-number input").on("keyup change", function() {
    var value = $(this).val();
    if (value <= 1) {
      $(this)
        .closest("li")
        .find(".minus")
        .addClass("disabled");
    } else {
      $(this)
        .closest("li")
        .find(".minus")
        .removeClass("disabled");
    }

    var group_value = 0;

    $(".guest-selector .guest-number input").each(function() {
      group_value = parseInt(group_value) + parseInt($(this).val());

      $(".guest-selector-trigger > span i").text(group_value);
    });
  });

  $(".configurator").each(function() {
    const $widget = $(this);
    const packageId = $widget.data("package-id");
    const checkInStartDate = $widget.data("check-in-start-date");
    const checkInEndDate = $widget.data("check-in-end-date");
    const checkOutStartDate = $widget.data("check-out-start-date");
    const checkOutEndDate = $widget.data("check-out-end-date");
    const checkInDefaultDate = $widget.data("check-in-default-date");
    const checkOutDefaultDate = $widget.data("check-out-default-date");

    const $spinnerValue = $widget.find(".spinner__value");
    const $button = $widget.find(".widget__button");
    let customers = 1;

    flatpickr(".checkInDate", {
        minDate: checkInStartDate,
        maxDate: checkInEndDate,
        altInput: true,
        altFormat: "F J, Y",
        defaultDate: checkInDefaultDate
    });

    flatpickr(".checkOutDate", {
        minDate: checkOutStartDate,
        maxDate: checkOutEndDate,
        altInput: true,
        altFormat: "F J, Y",
        defaultDate: checkOutDefaultDate
    });

    const updateButton = () => {
      if (checkInDate && checkOutDate && customers) {
        $button.removeAttr("disabled");
      }
    };


    $button.click(() => {

        let [checkInDate] = document.querySelector(".checkInDate")._flatpickr.selectedDates;
        let [checkOutDate] = document.querySelector(".checkOutDate")._flatpickr.selectedDates;

        checkInDate = flatpickr.formatDate(checkInDate, 'Y-m-d');
        checkOutDate = flatpickr.formatDate(checkOutDate, 'Y-m-d');

      let uri = URI($widget.data("base-url"))
        .setQuery("adults", $spinnerValue[0].value)
        .setQuery("package_id", packageId)
        .setQuery("check_in_date", checkInDate)
        .setQuery("check_out_date", checkOutDate);

        window.open(uri.toString());
    });
  });
});
